import { VueMaskDirective } from 'v-mask'

export default defineNuxtPlugin((nuxtApp) => {
  const v2 = VueMaskDirective
  const v3 = {
    beforeMount: v2.bind,
    updated: v2.componentUpdated,
    unmounted: v2.unbind,
  }

  nuxtApp.vueApp.directive('mask', v3)
})
